import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CardiovascularRiskEnum} from '../../enums/record';

@Component({
  selector: 'app-thermometer',
  templateUrl: './thermometer.component.html',
  styleUrls: ['./thermometer.component.scss']
})
export class ThermometerComponent implements OnInit, OnChanges {
  @Input() percentage = 0;
  @Input() risk: CardiovascularRiskEnum;

  get getPercentageColor(): string {
    if (!this.percentage) return '#74c7ab';
    if (this.percentage > 0 && this.percentage < 23) return '#74c7ab';
    if (this.percentage > 23 && this.percentage < 69 ) return '#EFB68A';
    return '#ed576b';
  }

  constructor() {
    this.percentage = 0;
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.risk) {
      if (changes.risk.previousValue === changes.risk.currentValue) return;
      if (this.risk === CardiovascularRiskEnum.VERY_SLIGHT) {
        this.percentage = 0;
      } else if (this.risk === CardiovascularRiskEnum.MILD) {
        this.percentage = 23;
      } else if (this.risk === CardiovascularRiskEnum.MODERATE) {
        this.percentage = 46;
      } else if (this.risk === CardiovascularRiskEnum.HIGH) {
        this.percentage = 69;
      } else if (this.risk === CardiovascularRiskEnum.VERY_HIGH) {
        this.percentage = 92;
      }
    }
  }

}
